namespace Nobox.CRM {
    export interface TaskcommentRow {
        Id?: number;
        TaskId?: number;
        BoardId?: number;
        UserId?: number;
        Text?: string;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
        TaskIndex?: number;
        TaskBoardId?: number;
        TaskListId?: number;
        TaskNama?: string;
        TaskKet?: string;
        TaskColor?: string;
        TaskTags?: string;
        TaskKontakId?: number;
        TaskLampiran?: string;
        TaskMulai?: string;
        TaskSelesai?: string;
        TaskIn?: string;
        TaskUp?: string;
        TaskInBy?: number;
        TaskUpBy?: number;
    }

    export namespace TaskcommentRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Text';
        export const localTextPrefix = 'Nobox.Taskcomment';
        export const deletePermission = 'Tasks:Delete';
        export const insertPermission = 'Tasks:Modify';
        export const readPermission = 'Tasks:View';
        export const updatePermission = 'Tasks:Modify';

        export declare const enum Fields {
            Id = "Id",
            TaskId = "TaskId",
            BoardId = "BoardId",
            UserId = "UserId",
            Text = "Text",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy",
            TaskIndex = "TaskIndex",
            TaskBoardId = "TaskBoardId",
            TaskListId = "TaskListId",
            TaskNama = "TaskNama",
            TaskKet = "TaskKet",
            TaskColor = "TaskColor",
            TaskTags = "TaskTags",
            TaskKontakId = "TaskKontakId",
            TaskLampiran = "TaskLampiran",
            TaskMulai = "TaskMulai",
            TaskSelesai = "TaskSelesai",
            TaskIn = "TaskIn",
            TaskUp = "TaskUp",
            TaskInBy = "TaskInBy",
            TaskUpBy = "TaskUpBy"
        }
    }
}
